module.exports = __webpack_public_path__ + "img/5.e95275c9.jpg";